import { Button, Container, CssBaseline, makeStyles, TextField, Typography, Input, InputAdornment, InputLabel, IconButton, FormControl, Grid, List, ListItem, Box } from "@material-ui/core";
import { COLORS } from '../Theme'

import React, { Fragment, useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { SIcon } from "../Icon";

import { useCookies } from "react-cookie";
import { useSnackbar } from 'notistack';
import ToastStr from '../../request/toastStr';
import '../css/modal.css';
import map from './headAdminMap'

import axios from 'axios';
import { admin as v_admin, basic, Values, SNACKBAR_TIME } from '../../request/values';
import MapContainer from "./headAdminMap";

import DaumPostcode from "react-daum-postcode";
import ReactDom from 'react-dom';
//const SERVER = basic.server;

const useStyles = makeStyles((theme) => ({

    nanumSquare_regular: {
        fontFamily: 'NanumR',
    },
    background: {
        width: '100vw',
        height: '100vh',
        background: `url("/images/background.png")`,
    },
    content: {
        width: '100%',
        height: '100%',
        display: 'grid',
        gridTemplateColumns: '230px 1fr',
    },
    sidebar: {
        display: 'grid',
        gridTemplateRows: '60px 80px 100px 100px 100px 1fr',
        backgroundColor: `${COLORS.LIGHT_BLUE_GREY}`,
    },
    mainPage: {
        display: 'grid',
        gridTemplateRows: '60px 1fr',
    },
    title: {
        margin: 'auto 0px auto 35px',
        fontFamily: 'NanumR',
        fontSize: '1.5rem',
        fontWeight: 'bold',
        color: `${COLORS.WHITE}`,
    },
    logo: {
        display: 'flex',
        alignItems: 'center',
        border: 'solid white',
        cursor: 'pointer',
        borderWidth: '0px 0px 1px 0px',
        "& img": {
            width: 'auto',
            maxHeight: '50%',
            margin: '10px',
        },
        "& #name": {
            display: 'inline-block',
            margin: 'auto 0px auto 0px',
            fontFamily: 'NanumR',
            fontSize: '1.5rem',
            fontWeight: 'bolder',
        },
    },
    userinfo: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        border: 'solid white',
        borderWidth: '0px 0px 1px 0px',
        "& #name": {
            display: 'inline-block',
            fontFamily: 'NanumR',
            fontSize: '1.25rem',
            fontWeight: 'bolder',
        },
    },
    menu: {
        border: 'solid white',
        borderWidth: '0px 0px 1px 0px',
        "& ul": {
            marginTop: '10px',
            "& li": {
                fontSize: '1rem',
                fontWeight: 'bolder',
                color: `${COLORS.SLATE_GREY}`,
                "& ul": {
                    listStyle: 'none',
                    paddingLeft: '0px',
                    "& li": {
                        fontSize: '1rem',
                        fontWeight: 'normal',
                        margin: '0px',
                        cursor: 'pointer',
                    }
                }
            }
        }

    },
    navigator: {
        display: 'grid',
        gridTemplateColumns: '3fr 2fr',
        backgroundColor: `${COLORS.WATER_BLUE}`,
    },
    form: {
        display: 'flex',
        width: '100%',
        height: '100%',
        justifyContent: 'center',
        alignItems: 'center',
        margin: 'auto',
        gap: '5%',
        "& input": {
            width: '70%',
            height: '55%',
        },
        "& Button": {
            border: 'solid 1px',
        }
    },
    classList: {
        "& #createClass": {
            padding: '5px 25px',
            margin: '1.5vh 0',
            color: `${COLORS.WHITE}`,
            borderRadius: '10px',
            backgroundColor: `${COLORS.WATER_BLUE}`,
        },
    },
    table: {
        display: 'grid',
        gridTemplateRows: '1fr 7fr 1fr 7fr 1.5fr',
        width: '95%',
        height: '85vh',
        margin: '1% auto',  
        border: 'solid 2px',
        borderRadius: '10px',
        backgroundColor: `${COLORS.WHITE}`,
        "& #downInfo": {
            border: "none",
        },
    },
    tableTitle: {
        display: 'flex',
        alignItems: 'center',
        padding: '10px 15px',
        border: 'solid lightgray',
        borderWidth: '0 0 2px 0',
    },
    titleName: {
        fontSize: '1rem',
        fontWeight: 'bold',
        color: `${COLORS.SLATE_GREY}`, 
    },
    tableInfo: {
        display: 'grid',
        gridTemplateRows: '1fr 1fr 1fr 10px',   
        border: 'solid lightgray',
        borderWidth: '0 0 2px 0',
        "& #interest": {
            gridTemplateColumns: "1fr 1fr 1fr",
            gap: '0 15px',
        },
        "& input": {
            borderColor: 'black',
            borderRadius: '10px',
            maxHeight: '50px',
        },
        "& select": {
            maxHeight: '50px',
            padding: '5px',
            fontFamily:'Nanumgothic',
            appearance : 'none',
        },
        "& #codeContainer": {
            display: 'grid',
            gridTemplateColumns: '1fr 150px',
            "& #classCode": {
                margin: '0 15px 0 0',
            },
            "& #classPlace": {
                margin: '0 15px 0 0',
            },
        },
    },
    checkInput: {
        borderColor: 'black',
        borderRadius: '10px',
        maxHeight: '50px',
    },
    nonInput: {
        background: 'lightgray',
        color: 'gray',
        borderColor: 'black',
        borderRadius: '10px',
        maxHeight: '50px',
    },
    checkBtn: {
        maxHeight: '50px',
        width: '100%',
        borderRadius: '10px',
        margin: '0 auto',
        color: `${COLORS.WHITE}`,
        backgroundColor: `${COLORS.PUMPKIN}`
    },
    nonBtn: {
        maxHeight: '50px',
        width: '100%',
        borderRadius: '10px',
        margin: '0 auto',
        color: `${COLORS.WHITE}`,
        backgroundColor: `${COLORS.LIGHT_GREY}`
    },
    infoContainer: {
        padding: '5px 30px',
        display: 'grid',
        gridTemplateRows: '30px 1fr',
    },
    buttonContainer:{
        display: 'grid',
        gridTemplateColumns: '1fr 10vw 3vw',
    },
    classInfo: {
        display: 'grid',
        gridTemplateColumns: '3fr 4fr 8fr 3fr',
        padding: '25px 0',
        backgroundColor: `${COLORS.LIGHT_GREY}`,
    },
    selectBox: {
        maxHeight: '50px',
        position: 'relative',
        width: '100%',
        height: '100%',
        borderRadius: '10px',
        border: '2px solid black',
    },
    select: {
        width: 'inherit',
        height: 'inherit',
        background: 'transparent',
        border: '0 none',
        outline: '0 none',
        padding: '0 5px',
        position: 'relative',
        zIndex: 3,
    },
    arrowIcon: {
        position: 'absolute',
        // backgroundColor: `${COLORS.WATER_BLUE}`,
        top: '0',
        right: '0', 
        zIndex: 1,
        width: '40px', 
        height: 'inherit',
        borderLeft: '2px solid black',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        "& img": {
            width: '50%',
        },
    },
    buttonLabel: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        color: `${COLORS.CHARCHOAL_GREY}`,
        fontSize: 18,
        fontFamily: 'NanumB',
        fontWeight: 'bold',
        lineHeight: '21px',
    },
    searchAddr: {
        borderWidth: 2,
        borderStyle: 'solid',
        borderColor: `${COLORS.CHARCHOAL_GREY}`,
        backgroundColor: `${COLORS.PUMPKIN}`,
        borderRadius: '10px',
        margin: '0.5vh',
        width: '15vw',
        height: '45vh',
    },
}));

const SERVER = basic.server
const { kakao } = window;

export interface propsType {
    searchKeyword: string
}

const HeadAdminCreateClass: React.FC<any> = (props) => {

    const classes = useStyles();

    const { member } = props;
    const [classCode, setClassCode] = useState<any | null>();
    const [className, setClassName] = useState<any | null>();
    const [classPlace, setClassPlace] = useState<any | null>();
    const [initStock, setInitStock] = useState<any | null>();
    const [maxLoan, setMaxLoan] = useState<any | null>();
    const [interest, setInterest] = useState<any | null>();
    const [interestTime, setInterestTime] = useState<any | null>();
    const [interestHms, setInterestHms] = useState<any | null>();
    const [auth, setAuth] = useState<boolean>(false);
    const [codecheck, setCodecheck] = useState<boolean>(false);
    const [modalOpen, setModalOpen] = useState<boolean>(false);
    const [clicked, setflag] = useState<boolean>(true);
    const [codevalidate, setflags] = useState<boolean>(true);

    const history = useHistory();

    const [cookies, setCookie, removeCookie] = useCookies();
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();

    const classCodeCheck = () => {
        setAuth((prevState) => true);
        let url = new URL(SERVER + v_admin.admin + v_admin.auth_class_info);
        let params = { 'classCode': classCode ? classCode.toString().trim() : '', 'action': 'join' }
        url.search = new URLSearchParams(params).toString();

        axios({
            method: 'GET',
            withCredentials: true,
            url: url.toString(),
        }).then((res) => {
            return res.data
        }).then((data: any) => {
            console.log(data);
            if (data.code == Values.SUCCESS_CODE) {
                enqueueSnackbar(ToastStr.CLASS_CODE_DUPLICATION, { variant: "warning", autoHideDuration: SNACKBAR_TIME })
            } else if (data.code == Values.FAIL_CODE) {
                // this is success == dont exist same id
                enqueueSnackbar(ToastStr.CLASS_AUTH_SUCCESS_STR, { variant: "success", autoHideDuration: SNACKBAR_TIME * 2 })
                setAuth((prevState) => true);
                setflags(false);
                document.getElementById("classCode")?.setAttribute("readonly", "readonly");
            }
        })
    }
    const handleButton = (e: any) => {
        if (auth) {
          enqueueSnackbar(ToastStr.CLASS_AUTH_SUCCESS_STR, { variant: "success", autoHideDuration: SNACKBAR_TIME })
          setflags(false)
          document.getElementById("classCode")?.setAttribute("readonly", "readonly");
        } else {
            // setAnimation(true);
            if (classCode == null)
                enqueueSnackbar(ToastStr.CLASS_CODE_CHECK_STR, { variant: "warning", autoHideDuration: SNACKBAR_TIME })
            else
                classCodeCheck();
        }
    }

    const valueChangeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { id, value } = e.target;
    
        if (id == 'classCode') setClassCode(value);
        else if (id == 'className') setClassName(value);
        else if (id == 'classPlace') setClassPlace(value);
        else if (id == 'initStock') setInitStock(value);
        else if (id == 'maxLoan') setMaxLoan(value);
        else if (id == 'interest') setInterest(value);
        else if (id == 'interestTime') setInterestTime(value);
        else if (id == 'interestHms') setInterestHms(value);
    }

    const valueChangeHandler2 = (e: React.ChangeEvent<HTMLSelectElement>) => {
        const { value } = e.target;
        setInterestHms(value)
    }
    
    const classCreate = (event: any) => {
        if(!auth)
            enqueueSnackbar(ToastStr.CHECK_VALIDATE_CODE_STR, { variant: "warning", autoHideDuration: SNACKBAR_TIME })
        else if(isNaN(initStock) || isNaN(maxLoan) || isNaN(interest) || isNaN(interestTime))
            enqueueSnackbar(ToastStr.CHECK_MONEY_INFO_STR, { variant: "warning", autoHideDuration: SNACKBAR_TIME })
        else{
            axios({
                method: "POST",
                data: {
                    classCode: classCode,
                    className: className,
                    classPlace: classPlace,
                    initStock: initStock,
                    maxLoan: maxLoan,
                    interest: interest,
                    interestTime: interestTime,
                    interestHms: interestHms,
                    email: member.id,
                },
                withCredentials: true,
                url: SERVER + v_admin.admin + v_admin.create,
            }).then((res) => {
                return res.data
            }).then((data: any) => {
                console.log(data)
                console.log(data.code)
                if (data.code == Values.SUCCESS_CODE) {
                    enqueueSnackbar(ToastStr.CLASS_CREATE_SUCCESS_STR, { variant: 'success', autoHideDuration: SNACKBAR_TIME })
                    history.push({
                        pathname: '/headadminClasslist',
                    });
                } else {
                    if (data.code == Values.FAIL_CODE) {
                        enqueueSnackbar(ToastStr.CLASS_CREATE_FAIL_STR, { variant: "warning", autoHideDuration: SNACKBAR_TIME })
                    } else {
                        enqueueSnackbar(ToastStr.REQUEST_GET_POST_FAIL_STR, { variant: "error", autoHideDuration: SNACKBAR_TIME })
                    }
                }
            })
        }
    }

    const moveMaterialList = () => {
        history.push('/headAdminMaterialList')
    }
    const moveProductList = () => {
        history.push('/headAdminLicenseList')
    }
    const moveClassList = () => {
        history.push('/headAdminClassList')
    }
    const moveClassManage = () => {
        history.push('/headAdminClassManage')
    }
    const moveMemberList = () => {
        history.push('/headAdminMemberList')
    }
    const moveAccountManage = () => {
        history.push('/headAdminAccountManage')
    }

    const openModal = () => {
        setModalOpen(true);
    };
    const closeModal = () => {
        setModalOpen(false);
    };
    const getAddress = (address: any) => {
        document.getElementById("classPlace")?.setAttribute("value",address)
        document.getElementById("classPlace")?.setAttribute("readonly", "readonly")
        setClassPlace(address)
        setflag(false)
        // document.getElementById("classPlace")?.style.background = lightgray;
    }
    const nothing = () => {

    }

    return (
        <div className={classes.background}>
            <CssBaseline />
            <div className={classes.content}>
                <div className={classes.sidebar}>
                    <div className={classes.logo} onClick={(e) => moveClassList()}>
                        <img src="/images/p.webp"></img>
                        <Typography id="name">플레이스타트업</Typography>
                    </div>
                    <div className={classes.userinfo}>
                        <Typography id="name">{member.name}님, 환영합니다!</Typography>
                    </div>
                    <div className={classes.menu}>
                        <ul>
                            <li>
                                품목 관리
                                <ul>
                                    <li onClick={(e) => moveMaterialList()}>재료 목록</li>
                                    <li onClick={(e) => moveProductList()}>제품 목록</li>
                                </ul>
                            </li>
                        </ul>
                    </div>
                    <div className={classes.menu}>
                        <ul>
                            <li>
                                교육 관리
                                <ul>
                                    <li onClick={(e) => moveClassList()}>교육 목록</li>
                                    <li onClick={(e) => moveClassManage()}>교육 관리 목록</li>
                                </ul>
                            </li>
                        </ul>
                    </div>
                    <div className={classes.menu}>
                        <ul>
                            <li>
                                회원 관리
                                <ul>
                                    <li onClick={(e) => moveMemberList()}>회원 목록</li>
                                    <li onClick={(e) => moveAccountManage()}>기업 계정 관리</li>
                                </ul>
                            </li>
                        </ul>
                    </div>
                </div>
                <div className={classes.mainPage}>
                    <div className={classes.navigator}>
                        <div className={classes.title}>클래스 개설</div>
                        <div className={classes.form}>
                        </div>
                    </div>
                    <div className={classes.classList}>
                        <div className={classes.table}>
                            <div className={classes.tableTitle}>
                                <Typography className={classes.titleName}>교육 정보 입력</Typography>
                            </div>
                            <div className={classes.tableInfo}>
                                <div className={classes.infoContainer}>
                                    <Typography>클래스 코드</Typography>
                                    <div id="codeContainer">
                                        <input type="text" id="classCode" className={codevalidate? classes.checkInput : classes.nonInput} onChange={valueChangeHandler}></input>

                                        <Button id="codeValidate" className={codevalidate? classes.checkBtn : classes.nonBtn} onClick={codevalidate ? handleButton : nothing}>
                                            <Typography>
                                                코드 중복 체크
                                            </Typography>
                                        </Button>
                                    </div>
                                </div>
                                <div className={classes.infoContainer}>
                                    <Typography>교육명</Typography>
                                    <input type="text" id="className" onChange={valueChangeHandler}></input>
                                </div>
                                <div className={classes.infoContainer}>
                                    <Typography>교육 장소</Typography>
                                    <div id="codeContainer">
                                        <input type="text" id="classPlace" className={clicked ? classes.checkInput : classes.nonInput} onClick={clicked ? openModal : nothing}></input>

                                        <Button id="searchAddr" className={clicked ? classes.checkBtn : classes.nonBtn} onClick={clicked ? openModal : nothing}>
                                            <Typography>
                                                주소 검색
                                            </Typography>
                                        </Button>
                                    </div>
                                    <Modal open={modalOpen} close={closeModal} header="Search_Map" getAddress = {getAddress} />
                                    
                                    {/*
                                    <Button id="searchPlace" onClick={openModal}>
                                        <Typography>
                                            주소 검색
                                        </Typography>
                                    </Button>
                                    <Modal2 open={modalOpen} close={closeModal} header="Search_Add" getAddress = {getAddress} >
                                        hihi
                                    </Modal2>
                                    */}
                                </div>
                            </div>
                            <div className={classes.tableTitle}>
                                <Typography className={classes.titleName}>자금 정보 입력</Typography>
                            </div>
                            <div className={classes.tableInfo} id="downInfo">
                                <div className={classes.infoContainer}>
                                    <Typography>기업 초기 자본금</Typography>
                                    <input type="text" id="initStock" onChange={valueChangeHandler}></input>
                                </div>
                                <div className={classes.infoContainer}>
                                    <Typography>최대 대출 금액</Typography>
                                    <input type="text" id="maxLoan" onChange={valueChangeHandler}></input>
                                </div>
                                <div className={classes.infoContainer} id="interest">
                                    <Typography>이자율</Typography>
                                    <Typography>이자 주기</Typography>
                                    <Typography>단위 설정(시,분,초)</Typography>
                                    <input type="text" id="interest" onChange={valueChangeHandler}></input>
                                    <input type="text" id="interestTime" onChange={valueChangeHandler}></input>
                                    <div className={classes.selectBox}>
                                        <select className={classes.select} onChange={valueChangeHandler2}>
                                            <option value="" selected></option>
                                            <option value="시">시</option>
                                            <option value="분">분</option>
                                            <option value="초">초</option>
                                        </select>
                                        <span className={classes.arrowIcon}>
                                            <img src="/images/down_blue.webp"></img>
                                        </span>
                                    </div>  
                                </div>
                            </div>
                            <div className={classes.buttonContainer}>
                                <div></div>
                                <Button id="createClass" onClick={classCreate}>
                                    <Typography>
                                        개설하기
                                    </Typography>
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

const Modal: React.FC<any> = props => {
    const { open, close, header, getAddress } = props;

    const [Keyword, setKeyword] = useState("");
    const handlePostCode = (data: any) => {
        let fullAddress = data.address;
        let extraAddress = ''; 
        
        if (data.addressType === 'R') {
          if (data.bname !== '') {
            extraAddress += data.bname;
          }
          if (data.buildingName !== '') {
            extraAddress += (extraAddress !== '' ? `, ${data.buildingName}` : data.buildingName);
          }
          fullAddress += (extraAddress !== '' ? ` (${extraAddress})` : '');
        }
        console.log(data)
        console.log(fullAddress)
        getAddress(fullAddress)
        close()
    }
    return ( 
        <div className={open ? 'openModal modal' : 'modal'}>
            {open ? (
            <section>
                <header>
                    {header}
                    <button className="close" onClick={close}>
                    &times;
                    </button>
                </header>
                <main>
                    <DaumPostcode onComplete={handlePostCode} />
                </main>
                
                <footer>
                    <button className="close" onClick={close}>close</button>
                </footer>
            </section>
            ) : null}
            <MapContainer searchKeyword={ Keyword }/>
        </div>
    )
}

export default HeadAdminCreateClass;